'use client'

import { motion } from 'framer-motion'

export function PhaseAdvisory() {
  return (
    <section id="advisory" className="pb-16 md:pb-24 scroll-mt-16">
      <div className="container max-w-7xl mx-auto px-6">
        <div className="backdrop-blur-2xl bg-white/[0.03] border border-[#3e4658] rounded-[40px] lg:rounded-[60px] p-8 md:p-12 lg:p-16">
          <div className="grid lg:grid-cols-2 gap-12">
            <div>
              <motion.p
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                className="text-[#61d8fe] text-lg font-anuphan mb-4"
              >
                Phase 4 — Scoped Engagements
              </motion.p>
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-white text-3xl md:text-[48px] font-normal leading-[1.1] font-gendy mb-6"
              >
                Advisory
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="text-white text-xl md:text-[26px] leading-[1.4] font-anuphan mb-4"
              >
                Strategic AI consulting, scoped to your needs.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.15 }}
                className="text-[#bdbdbd] text-lg font-anuphan leading-relaxed mb-4"
              >
                For organizations that need ongoing strategic guidance without a fixed monthly retainer. We scope each engagement to your specific challenges — whether that&apos;s evaluating AI vendors, designing governance frameworks, or steering a transformation already in motion.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="text-[#8a8f9e] text-sm font-anuphan mb-8"
              >
                Every engagement is scoped individually. Let&apos;s talk about what you need.
              </motion.p>
              <a
                href="mailto:alex@behmn.com?subject=Advisory%20Inquiry%20%E2%80%94%20Strategic%20AI%20Consulting&body=Hi%20Alex%2C%0A%0AI%E2%80%99m%20interested%20in%20your%20Advisory%20services%20%E2%80%94%20scoped%20AI%20consulting.%0A%0AHere%E2%80%99s%20what%20I%E2%80%99m%20working%20on%20and%20where%20I%20need%20guidance%3A%0A%0A%5BYour%20name%2C%20company%2C%20and%20what%20challenges%20you%E2%80%99re%20facing%5D%0A%0ALooking%20forward%20to%20connecting."
                className="inline-block bg-[#544ae8] border border-[#475065] rounded-[100px] px-10 py-4 text-white text-lg font-anuphan hover:scale-[1.02] active:scale-[0.98] transition-transform"
              >
                Discuss Your Needs
              </a>
            </div>

            <div className="space-y-4">
              {[
                {
                  title: 'Strategic Assessment',
                  desc: 'Deep-dive analysis of your AI readiness, vendor landscape, and transformation priorities. Clear recommendations you can act on.',
                },
                {
                  title: 'Implementation Guidance',
                  desc: 'Hands-on advisory as you execute — reviewing architecture decisions, evaluating tools, and course-correcting before problems compound.',
                },
                {
                  title: 'Executive Coaching',
                  desc: 'One-on-one sessions with senior advisors to sharpen your AI strategy, build internal buy-in, and lead transformation with confidence.',
                },
              ].map((item, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08 }}
                  className="bg-white/[0.03] border border-[#3e4658] rounded-[16px] p-5 hover:border-[#61d8fe]/20 transition-colors"
                >
                  <p className="text-white font-semibold font-anuphan mb-1">{item.title}</p>
                  <p className="text-[#8a8f9e] text-sm font-anuphan">{item.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
